module.exports = __webpack_public_path__ + "assets/img/13_330_big.6461d5eb.jpg";